import { render, staticRenderFns } from "./DisplayTitle.vue?vue&type=template&id=cb13daca&scoped=true"
import script from "./DisplayTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayTitle.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb13daca",
  null
  
)

export default component.exports